var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIa2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 152,
    viewBox: "0 0 56 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7184 26.2028C54.6393 11.6441 42.7873 0.175781 28.3255 0.175781C13.8637 0.175781 2.01174 11.6441 0.932639 26.2028H0.852539V121.635H0.932639C0.879626 122.351 0.852539 123.074 0.852539 123.804C0.852539 139.376 13.1526 152 28.3255 152C43.4984 152 55.7985 139.376 55.7985 123.804C55.7985 123.074 55.7714 122.351 55.7184 121.635H55.7985V26.2028H55.7184Z",
    fill: "#F39100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIa2);
export default __webpack_public_path__ + "static/media/IA_2.3f650f2d0f4d49fb97897c59118ee8cf.svg";
export { ForwardRef as ReactComponent };